import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Container, Content, Icon, Text, Visibility } from '../styled';

var Banner = /*#__PURE__*/function (_React$Component) {
  _inherits(Banner, _React$Component);

  var _super = _createSuper(Banner);

  function Banner() {
    var _this;

    _classCallCheck(this, Banner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      height: 0
    });

    _defineProperty(_assertThisInitialized(_this), "getHeight", function () {
      if (_this.containerRef) {
        _this.setState({
          height: _this.containerRef.clientHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "innerRef", function (ref) {
      _this.containerRef = ref;

      if (_this.props.innerRef) {
        _this.props.innerRef(ref);
      }

      _this.getHeight();
    });

    _defineProperty(_assertThisInitialized(_this), "getA11yProps", function (appearance) {
      var isOpen = _this.props.isOpen;
      var defaultProps = {
        'aria-hidden': !isOpen,
        role: 'alert'
      };

      if (appearance === 'announcement') {
        return _objectSpread(_objectSpread({}, defaultProps), {}, {
          'aria-label': 'announcement',
          tabIndex: 0,
          role: 'region'
        });
      }

      return defaultProps;
    });

    return _this;
  }

  _createClass(Banner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          children = _this$props.children,
          icon = _this$props.icon,
          isOpen = _this$props.isOpen,
          testId = _this$props.testId;
      var allyProps = this.getA11yProps(appearance);
      return /*#__PURE__*/React.createElement(Visibility, {
        bannerHeight: this.state.height,
        isOpen: isOpen
      }, /*#__PURE__*/React.createElement(Container, _extends({
        innerRef: this.innerRef,
        appearance: appearance,
        "data-testid": testId
      }, allyProps), /*#__PURE__*/React.createElement(Content, {
        appearance: appearance
      }, /*#__PURE__*/React.createElement(Icon, null, icon), /*#__PURE__*/React.createElement(Text, {
        appearance: appearance
      }, children))));
    }
  }]);

  return Banner;
}(React.Component);

_defineProperty(Banner, "defaultProps", {
  appearance: 'warning',
  isOpen: false
});

export default Banner;